<template>

  <div id="underwriting-tools-page-download-all">
    <div class="flex-grow py-4 main-title">
      <h1>{{ title }}</h1>
    </div>
    <vs-row class="card-row" vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
        <vs-card>
          <div>
            <vs-row vs-justify="center">
              <font-awesome-icon
                  v-if="downloading"
                  class="my-12 icon download fa-pulse"
                  size="lg"
                  :icon="['far', 'spinner']"/>
              <font-awesome-icon
                  v-else-if="success"
                  class="my-12 icon success"
                  size="lg"
                  :icon="['far', 'check-circle']"/>
              <font-awesome-icon
                  v-else
                  class="my-12 icon error"
                  size="lg"
                  :icon="['far', 'times-circle']"/>
            </vs-row>
            <vs-row vs-justify="center">
              <h1 class="mb-6">
                {{ cardTitle }}
              </h1>
            </vs-row>
            <vs-row vs-justify="center">
              <div class="mb-16 cardText">
                {{ cardText }}
              </div>
            </vs-row>
            <vs-row v-if="downloading" vs-justify="center">
              <div class="mb-16 cardInfo">
                {{ cardInfo }}
              </div>
            </vs-row>
            <vs-row v-if="!downloading && success" vs-justify="center">
              <div class="mb-16 buttons">
                <vs-button
                    class="download-button"
                    text-color="#32B93B"
                    type="border"
                    @click="$emit('downloadAll', downloadFile)"
                    color="#32B93B"
                >

                  <font-awesome-icon size="lg" :icon="['fas', 'download']"/>
                  {{  $t('DownloadFile') }}
                </vs-button>
              </div>
            </vs-row>
            <vs-row v-if="!downloading" vs-justify="center">
              <div class="mb-8 buttons">
                <vs-button
                    class="mr-4"
                    @click="$emit('closeDownloadAllModal')"
                    color="light"
                >
                  {{ $t('ReturnToNotifyAClaim') }}
                </vs-button>
              </div>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'DownloadAll',
  props: {
    downloading: {
      type: Boolean,
      default: true,
    },
    success: {
      type: Boolean,
      default: true,
    },
    downloadFile: {
      type: Object,
    },
  },
  computed: {
    title() {
      if (this.downloading) {
        return this.$t('DownloadingFile');
      }

      if (this.success) {
        return this.$t('DownloadComplete');
      }

      return this.$t('DownloadFailed');
    },
    cardTitle() {
      if (this.downloading) {
        return this.$t('ProcessingDownload');
      }

      if (this.success) {
        return this.$t('YourDownloadIsReady');
      }

      return this.$t('SomethingWentWrong');
    },
    cardText() {
      if (this.downloading) {
        return this.$t('DownloadingMessage');
      }

      if (this.success) {
        return this.$t('ClickLinkToDownload');
      }

      return this.$t('GoBackToNotifyAClaim');
    },
    cardInfo() {
      return this.$t('ProcessCanTakeFewMinutes');
    }
  },
};

</script>

<style lang="scss" scoped>
@import '../../../assets/scss/custom/components/variables';

#underwriting-tools-page-download-all {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 50px;
  left: 0;
  padding: 0 1rem;

  @media (max-width: 1199px) {
    top: 19px;
  }

  .main-title {
    background-color: #f8f8f8;
    text-align: left;
    width: 100%;
  }

  .vs-card--content {
    width: 411px;
    height: 360px;
    font-size: 15px;
    margin: auto;
  }

  .card-row {
    padding-top: 120px;
    height: 976px;
    background: white;

    @media (max-width: 1199px) {
      padding-top: 0px;
    }

    > .vs-col {
      width: 465px !important;
    }
  }

  .download-button {
    margin-bottom: 1rem;
    font-size: 18px;
    padding: 16.5px 100px;
  }

  .cardTitle {
    font-size: 28px;
    text-align: center;
  }

  .card-text {
    font-size: 17px;
    text-align: center;
  }

  .card-info {
    font-size: 15px;
    text-align: center;
    color: #C8843F;
  }

  .icon {
    color: #444b5780;
    font-size: 44px;

    &.success {
      color: $green;
    }

    &.error {
      color: $red;
    }
  }

  .buttons {
    button {
      span {
        font-size: 16px;
        color: #000;
      }
    }
  }
}

</style>
